import { authFailure } from './auth-errors';

/** What a verification link's oobCode turned out to be, for EmailVerifiedScreen. */
export type VerificationLinkState = 'verified' | 'expired' | 'already-used' | 'invalid';

/**
 * What a failed applyActionCode means. Identity Platform rejects a used code and a malformed one alike with
 * auth/invalid-action-code, so a code is taken to be already used when the signed-in player is verified. Network and
 * rate-limit failures are undefined: the link may still be good, so the player can try again.
 */
export const verificationLinkFailure = (
  error: unknown,
  signedInAndVerified: boolean,
): Exclude<VerificationLinkState, 'verified'> | undefined => {
  const failure = authFailure(error);
  if (failure === 'network' || failure === 'too-many-requests') {
    return undefined;
  }
  switch ((error as { code?: unknown } | null)?.code) {
    case 'auth/expired-action-code':
      return 'expired';
    case 'auth/invalid-action-code':
      return signedInAndVerified ? 'already-used' : 'invalid';
    default:
      return 'invalid';
  }
};
